// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.discord-button {
  position: absolute;
  bottom: 1.95rem;
  right: 0.25rem;
  display: flex;
  width: 95px !important;
  padding: 0;
  margin-left: 0.25rem;
  margin-bottom: 0 !important;
  border-radius: 0.5rem;
  min-height: 32px;
  height: 32px;
}
@media (max-width: 768px) {
  .discord-button {
    position: static;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/settings/user/notification/style.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,oBAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;AACF;AACE;EAbF;IAcI,gBAAA;EAEF;AACF","sourcesContent":[".discord-button {\n  position: absolute;\n  bottom: 1.95rem;\n  right: 0.25rem;\n  display: flex;\n  width: 95px !important;\n  padding: 0;\n  margin-left: .25rem;\n  margin-bottom: 0 !important;\n  border-radius: .5rem;\n  min-height: 32px;\n  height: 32px;\n\n  @media (max-width: 768px) {\n    position: static;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
